import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

//auth
import createPersistedState from "vuex-persistedstate";
import user from "./modules/user.js";
import upload_file_store from "@/components/file-upload/upload_file_store.js";
import upload_file_img_store from "@/components/file-upload/upload_file_img_store.js";
import upload_file_resource_store from "@/components/file-upload/upload_file_resource_store.js";


export default new Vuex.Store({
  state: {
    currUser: null,
    FirebaseFunctionsURL: 'https://europe-west2-thinkair-task-portal.cloudfunctions.net'
  },
  plugins: [createPersistedState()],
  getters: {
    currUser(state) {
      // console.log("")
      return state.currUser;
    },
    FirebaseFunctionsURL(state) {
      return state.FirebaseFunctionsURL;
    }
  },
  mutations: {
    setUser(state, payload) {
      state.currUser = payload;
      //console.log("setUser: " + JSON.stringify(state.currUser))
    },
  },
  actions: {
  },
  modules: {
    user: user,
    upload_file_store: upload_file_store,
    upload_file_img_store: upload_file_img_store,
    upload_file_resource_store:upload_file_resource_store,


  }
})
